var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericParticulateMeterSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#455063}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m334.8 219c-35.7 0-64.5-28.8-64.5-64.5 0-35.7 28.8-64.5 64.5-64.5 35.7 0 64.5 28.8 64.5 64.5 0 35.7-28.8 64.5-64.5 64.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m99.4 375.6c-35.7 0-64.5-28.8-64.5-64.5 0-35.7 28.8-64.5 64.5-64.5 35.7 0 64.5 28.8 64.5 64.5 0 35.7-28.8 64.5-64.5 64.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m368.2 588c-35.7 0-64.5-28.8-64.5-64.5 0-35.7 28.8-64.5 64.5-64.5 35.7 0 64.5 28.8 64.5 64.5 0 35.7-28.8 64.5-64.5 64.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m534.6 296c-25.2 25.2-66 25.2-91.2 0-25.2-25.2-25.2-66 0-91.2 25.2-25.2 66-25.2 91.2 0 25.2 25.2 25.2 66 0 91.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m235.9 258.6c-20 4.8-40.1-7.6-44.8-27.7-4.8-20 7.6-40.1 27.7-44.9 20.1-4.7 40.1 7.7 44.9 27.8 4.7 20-7.7 40.1-27.8 44.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m132.5 504.3c-14.6 14.6-38.1 14.6-52.7 0-14.6-14.6-14.6-38.2 0-52.8 14.6-14.6 38.1-14.6 52.7 0 14.6 14.6 14.6 38.2 0 52.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m255.3 497.7c-14.6 14.6-38.2 14.6-52.8 0-14.6-14.5-14.6-38.1 0-52.7 14.6-14.6 38.2-14.6 52.8 0 14.5 14.6 14.5 38.2 0 52.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m435.3 426c-20.3 3.3-39.4-10.4-42.7-30.8-3.3-20.4 10.5-39.5 30.8-42.8 20.4-3.3 39.5 10.5 42.8 30.9 3.3 20.3-10.5 39.4-30.9 42.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m103.3 214c-20 4.8-40.1-7.6-44.8-27.7-4.8-20 7.6-40.1 27.7-44.9 20.1-4.7 40.1 7.7 44.9 27.8 4.7 20-7.7 40.1-27.8 44.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m480.5 484.4c-14.9 0-26.9-12-26.9-26.9 0-14.9 12-26.9 26.9-26.9 14.9 0 26.9 12 26.9 26.9 0 14.9-12 26.9-26.9 26.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m228.6 66.4c-14.9 0-26.9-12-26.9-26.9 0-14.9 12-26.9 26.9-26.9 14.9 0 26.9 12 26.9 26.9 0 14.9-12 26.9-26.9 26.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m456.7 158.1c-14.9 0-26.9-12-26.9-26.9 0-14.9 12-26.9 26.9-26.9 14.9 0 26.9 12 26.9 26.9 0 14.9-12 26.9-26.9 26.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m389.8 257.7c-10.6 0.9-19.9-7-20.8-17.6-0.9-10.7 7-20 17.6-20.9 10.7-0.8 20 7.1 20.9 17.7 0.8 10.6-7.1 19.9-17.7 20.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m227.7 557.2c-2.4 10.4-12.8 16.8-23.2 14.3-10.4-2.4-16.8-12.8-14.3-23.2 2.4-10.4 12.8-16.8 23.2-14.4 10.4 2.5 16.8 12.9 14.3 23.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m565.4 386.1c-10.6 0.9-19.9-7-20.8-17.7-0.9-10.6 7-19.9 17.7-20.8 10.6-0.9 19.9 7 20.8 17.7 0.8 10.6-7 19.9-17.7 20.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m188.2 154.6c-10.7 0-19.3-8.6-19.3-19.3 0-10.7 8.6-19.3 19.3-19.3 10.7 0 19.3 8.6 19.3 19.3 0 10.7-8.6 19.3-19.3 19.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m417.9 57.7c-1.1 10.6-10.5 18.4-21.1 17.3-10.6-1.1-18.4-10.5-17.3-21.1 1-10.6 10.5-18.4 21.1-17.3 10.6 1.1 18.4 10.5 17.3 21.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m190 413.5c-2.5 10.4-12.8 16.8-23.2 14.3-10.4-2.4-16.8-12.8-14.4-23.2 2.5-10.4 12.9-16.8 23.3-14.3 10.3 2.4 16.8 12.8 14.3 23.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m57.8 430.7c-10.7 0-19.3-8.6-19.3-19.3 0-10.7 8.6-19.3 19.3-19.3 10.7 0 19.3 8.6 19.3 19.3 0 10.7-8.6 19.3-19.3 19.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m29.5 237.3c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m294.4 250.1c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m151.6 85.8c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m330.1 34.7c-3.4 3.4-8.9 3.4-12.3 0-3.4-3.4-3.4-8.9 0-12.3 3.4-3.4 8.9-3.4 12.3 0 3.4 3.4 3.4 8.9 0 12.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m531.6 152.4c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m597.8 287.3c-1.9 4.4-6.9 6.5-11.4 4.7-4.4-1.8-6.5-6.9-4.7-11.4 1.9-4.4 6.9-6.5 11.4-4.7 4.4 1.9 6.5 7 4.7 11.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m565.6 459.6c-1.8 4.4-6.9 6.5-11.4 4.7-4.4-1.9-6.5-7-4.7-11.4 1.9-4.4 6.9-6.6 11.4-4.7 4.4 1.8 6.5 6.9 4.7 11.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m503.3 369.6c-1.8 4.4-6.9 6.5-11.4 4.7-4.4-1.9-6.5-6.9-4.7-11.4 1.9-4.4 7-6.5 11.4-4.7 4.4 1.8 6.5 6.9 4.7 11.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m304 445.9c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m281.5 580.9c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m14.8 370.6c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericParticulateMeterSymbol);
export default __webpack_public_path__ + "static/media/generic-particulate-meter-symbol.f21849993e315f4e290df4c40d91b965.svg";
export { ForwardRef as ReactComponent };